const LOCAL_SERVER_PORT = Number(import.meta.env.VITE_CUSTOMER_V2_PORT) || 3021
// Point to current host but the local customer-v2 service port.
// Could hardcode localhost, but this covers /etc/hosts file mappings too.
// eg:
// http://localhost:8990 -> http://localhost:3021/gqlv2
// http://pronto.local:8990 -> http://pronto.local:3021/gqlv2 (uses hosts file, server must be pronto.local for CORS)
// https://pronto.co.uk -> https://pronto.co.uk/gqlv2
export const baseUrl = `${window.location.protocol}//${
  window.location.hostname
}${window.location.port ? `:${LOCAL_SERVER_PORT}` : ''}`
export const baseUrlImages = import.meta.env.DEV
  ? import.meta.env.VITE_BASE_URL_IMAGES || 'https://test.redbox.systems'
  : baseUrl

export const apiUrlV2 = baseUrl + '/gqlv2'
